import { EMessengerChatSourceType, Regions } from '@xometry/ui';
import { amplitudeLogger } from 'amplitude';
import clsx from 'clsx';
import { MicroFrontend } from 'components/MicroFrontend/MicroFrontend';
import { MICRO_FRONTEND_NAME } from 'components/MicroFrontend/MicroFrontend.types';
import { CURRENT_REGION } from 'config/regions/config';
import { ENV_MESSENGER_URL } from 'constants/env';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getMessengerAppConfig } from 'utils/getMessengerAppConfig';
import { usePinnedMessagesEventBus } from 'utils/hooks/usePinnedMessagesEventBus';

import s from './PinnedMessages.module.less';

interface Props {
  className?: string;
  providerId?: string;
}

interface ResolveSourceArgs {
  dealId?: string;
  providerId?: string;
}

const PINNED_MESSAGES_CONTAINER_ID = 'PinnedMessagesContainer';

const resolveSource = ({ dealId, providerId }: ResolveSourceArgs) => {
  if (providerId) {
    return {
      sourceId: providerId,
      sourceType: EMessengerChatSourceType.PARTNER,
    };
  }

  if (dealId) {
    return {
      sourceId: dealId,
      sourceType: EMessengerChatSourceType.DEAL,
    };
  }

  return null;
};

const PinnedMessagesComponent: React.FC<Props> = ({ className, providerId }) => {
  const { setEventBusRef } = usePinnedMessagesEventBus();
  const match = useRouteMatch<{ dealId?: string }>();
  const dealId = match?.params?.dealId;
  const messengerAppConfig = React.useMemo(() => getMessengerAppConfig(), []);

  const source = resolveSource({ dealId, providerId });
  const sourceId = source?.sourceId;
  const sourceType = source?.sourceType;

  const appParams = React.useMemo(
    () =>
      sourceId && sourceType
        ? {
            sourceId,
            sourceType,
            region: CURRENT_REGION as Regions,
            config: messengerAppConfig,
            setEventBusRef,
            amplitudeLogger,
          }
        : null,
    [messengerAppConfig, setEventBusRef, sourceId, sourceType],
  );

  if (!source || !appParams) {
    return null;
  }

  return (
    <div className={clsx(className, s.root)}>
      <MicroFrontend
        name={MICRO_FRONTEND_NAME.PinnedMessages}
        containerId={PINNED_MESSAGES_CONTAINER_ID}
        host={ENV_MESSENGER_URL}
        appParams={appParams}
      />
    </div>
  );
};

export const PinnedMessages = observer(PinnedMessagesComponent);
